import React from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import SupportButton from '../common/SupportButton';

export function Layout() {
  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar */}
      <Sidebar />

      {/* Main content */}
      <div className="flex-1 flex flex-col min-w-0">
        {/* Header */}
        <Header />

        {/* Page content */}
        <main className="flex-1 p-6 overflow-auto">
          <Outlet />
        </main>
      </div>

      {/* Buton de suport - montat AICI, în layout, ca să apară pe toate paginile,
          inclusiv pe ecranele de încărcare sau de eroare ale paginilor (acelea
          ies din componenta paginii înainte de a randa conținutul, deci un buton
          montat în pagină nu s-ar vedea tocmai când ai mai mare nevoie de el).
          E în afara <main>, deci nu e afectat de scroll-ul conținutului.
          O singură instanță în toată aplicația: componenta folosește un id de
          formular fix, iar două instanțe simultane l-ar duplica. */}
      <SupportButton />
    </div>
  );
}
